export default {
    services: '1 service | {n} services',
    reservations: '1 reservation | {n} reservations',
    offer_company: 'Company services',
    offer_user: 'User services',
    no_slots_in_past: 'No reservations for the selected date',
    filter: 'Filter',
    error_slot_within_two_hours: 'Slots within next two hours cannot be edited',
    status_successfully_changed: 'Reservation status successfully changed',
    unavailable_slot: 'Slot is not available',
    shorten_reservation: 'Shorten reservation',
    go_to_next_month: 'Next month',
}
